export const onSortChangedEvent = ({ gridRef, onSortChanged, params }) => {
  if (onSortChanged) onSortChanged(params);
  gridRef.current.api.refreshCells({ force: true });
}